//Do not add any dependencies, such as hooks.
import React from "react";
import { Layout } from "views/Main/Layouts";
import { LocalKeys, useTranslation } from "utilities/i18n";

export const ErrorPage: React.FC<{ k?: LocalKeys }> = ({
  k = "ERROR_FATAL_APPLICATION"
}) => {
  const { t } = useTranslation();
  return (
    <Layout>
      <Layout.Content>{t(k)}</Layout.Content>
    </Layout>
  );
};
